module.exports = __webpack_public_path__ + "img/nice-basic.aca643d3.png";